import * as React from 'react';
import {Copy} from '@packages/systems/design-system/Text';

export const AccessGroupMaxLimit = ({
  accessGroupNames,
}: {
  accessGroupNames: string[];
}) => {
  return accessGroupNames.length ? (
    <div id="access-group-used-on-page-list">
      <Copy style={{padding: '5px'}}>Access groups used on this page:</Copy>
      {accessGroupNames.map((name, idx) => (
        <Copy
          // @ts-expect-error - TS2769 - No overload matches this call.
          id={`access-group-used-on-page-list-item-${idx}`}
          style={{padding: '5px'}}
          key={name}
        >
          {name}
        </Copy>
      ))}
      {accessGroupNames.length > 3
        ? `Oopsy daisy! You are using ${accessGroupNames.length}. The max is 3 per page.`
        : null}
    </div>
  ) : null;
};
